import { render, staticRenderFns } from "./FactorypricingList.vue?vue&type=template&id=4f6d46b6"
import script from "./FactorypricingList.vue?vue&type=script&lang=js"
export * from "./FactorypricingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports